import * as z from 'zod';

const StageSchema = z.enum([
  'matchweek',
  'round',
  'round_of_16',
  'round_of_32',
  'round_of_64',
  'quarter_final',
  'semi_final',
  'final',
  'third_place',
  'qualification_round',
  'play_off_round',
  'group_stage',
  'league_phase',
]);

export default StageSchema;
